import React, { FC, createContext, useReducer, ReactNode } from "react";
import { IDepoimentosContext } from "./Interfaces/IDepoimentosContext";
import { DepoimentosEffects } from "./Depoimentos.Effect";
import { DepoimentosReducers, INITIAL_STATE } from "./Depoimentos.Reducers";

export const DepoimentosContext = createContext<IDepoimentosContext>(
  {} as IDepoimentosContext
);

const DepoimentosProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(DepoimentosReducers, INITIAL_STATE);

  const effects = DepoimentosEffects(dispatch);

  return (
    <DepoimentosContext.Provider
      value={{
        ...state,
        effects: effects,
      }}
    >
      {children}
    </DepoimentosContext.Provider>
  );
};

export default DepoimentosProvider;
